import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationPayrollScreens,
  simulationPublicPayrollNewScreen,
} from '@/modules/simulation/route';
import { flowSearchSchema } from '@/shared/flow/define-flow';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Consignado público novo no caminho do legado (`router.tsx:1208-1212`, `resource='NovaSimulacao'`): o passo vai em
// `?passo=`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/contratar/consignado-publico/novo/')({
  validateSearch: flowSearchSchema(),
  staticData: { screen: simulationPublicPayrollNewScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationPayrollScreens, 'PublicPayrollRouteScreen'),
});
